import React from 'react';
import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
export var PictureSource = function PictureSource(_ref) {
  var height = _ref.height,
    minBreakpoint = _ref.minBreakpoint,
    srcSet = _ref.srcSet,
    width = _ref.width;
  return /*#__PURE__*/React.createElement("source", {
    height: height,
    key: minBreakpoint,
    media: "(min-width: ".concat(minBreakpoints[minBreakpoint], "px)"),
    srcSet: srcSet,
    width: width
  });
};